<style scoped>
.section-items h4 {
  line-height: 20px;
}
</style>
<template>
  <layout name="LayoutDefault">
    <div class="Authors">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row">
            <div class="filter-atoz col-lg-12">
              <ul class="list-inline">
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/A`"
                    :class="{ active: this.$route.params.type === 'A' }"
                    >A</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/B`"
                    :class="{ active: this.$route.params.type === 'B' }"
                    >B</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/C`"
                    :class="{ active: this.$route.params.type === 'C' }"
                    >C</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/D`"
                    :class="{ active: this.$route.params.type === 'D' }"
                    >D</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/E`"
                    :class="{ active: this.$route.params.type === 'E' }"
                    >E</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/F`"
                    :class="{ active: this.$route.params.type === 'F' }"
                    >F</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/G`"
                    :class="{ active: this.$route.params.type === 'G' }"
                    >G</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/H`"
                    :class="{ active: this.$route.params.type === 'H' }"
                    >H</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/I`"
                    :class="{ active: this.$route.params.type === 'I' }"
                    >I</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/J`"
                    :class="{ active: this.$route.params.type === 'J' }"
                    >J</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/K`"
                    :class="{ active: this.$route.params.type === 'K' }"
                    >K</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/L`"
                    :class="{ active: this.$route.params.type === 'L' }"
                    >L</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/M`"
                    :class="{ active: this.$route.params.type === 'M' }"
                    >M</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/N`"
                    :class="{ active: this.$route.params.type === 'N' }"
                    >N</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/O`"
                    :class="{ active: this.$route.params.type === 'O' }"
                    >O</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/P`"
                    :class="{ active: this.$route.params.type === 'P' }"
                    >P</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/Q`"
                    :class="{ active: this.$route.params.type === 'Q' }"
                    >Q</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/R`"
                    :class="{ active: this.$route.params.type === 'R' }"
                    >R</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/S`"
                    :class="{ active: this.$route.params.type === 'S' }"
                    >S</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/T`"
                    :class="{ active: this.$route.params.type === 'T' }"
                    >T</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/U`"
                    :class="{ active: this.$route.params.type === 'U' }"
                    >U</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/V`"
                    :class="{ active: this.$route.params.type === 'V' }"
                    >V</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/W`"
                    :class="{ active: this.$route.params.type === 'W' }"
                    >W</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/X`"
                    :class="{ active: this.$route.params.type === 'X' }"
                    >X</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/Y`"
                    :class="{ active: this.$route.params.type === 'Y' }"
                    >Y</a
                  >
                </li>
                <li class="list-inline-item">
                  <a
                    :href="`${baseUrl}authors/Z`"
                    :class="{ active: this.$route.params.type === 'Z' }"
                    >Z</a
                  >
                </li>
              </ul>
            </div>

            <div class="col-lg-12 ">
              <div class="section-items">
                <span v-if="loading">
                  <img
                    slot="preloader"
                    v-bind:src="`${baseUrl}/assets/img/loader.gif`"
                    title="Loading..."
                  />
                </span>

                <div class="row">
                  <div
                    v-for="(item, k) in authors"
                    :key="k"
                    class="col-lg-2 col-sm-6 col-6 section-item"
                  >
                    <a :href="`${baseUrl}author/${item.id}`">
                      <div class="author-img-holder">
                        <vue-load-image>
                          <img
                            slot="image"
                            v-bind:src="`${IMAGEURL}${item.image}`"
                            alt=""
                            class="img-responsive"
                          />
                          <img
                            slot="preloader"
                            v-bind:src="`${baseUrl}/assets/img/loader.gif`"
                            title="Image Loading..."
                          />
                          <div slot="error">can't load image</div>
                        </vue-load-image>
                      </div>
                      <h4>{{ item.author_name }}</h4>
                    </a>
                  </div>
                </div>

                <nav class="d-flex justify-content-center">
                  <ul class="pagination">
                    <li
                      v-for="(item, k) in links"
                      :key="k"
                      :class="getPagingClass(item)"
                    >
                      <a
                        class="page-link"
                        @click="getAuthors(item.url)"
                        href="javascript:;"
                        v-html="getPagingLabel(item)"
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import VueLoadImage from "vue-load-image";

export default {
  data() {
    return {
      loading: true,
      authors: null,
      links: null
    };
  },
  components: {
    Layout,
    "vue-load-image": VueLoadImage
  },
  methods: {
    getPagingLabel(item) {
      let string = item.label;
      string = string.replace("Next", "");
      string = string.replace("Previous", "");
      return string;
    },
    getPagingClass(item) {
      if (item.url && item.active === true) {
        return "page-item active";
      } else if(!item.url) {
        return "page-item disabled";
      }else{
             return "page-item";
      }
    },
    getAuthors(url = null) {
      if (!url) {
        if (this.$route.params.type == "all") {
          url = "author/all";
        } else {
          url = "author/all/" + this.$route.params.type;
        }
      }

      this.$http
        .get(url)
        .then(response => {
          this.loading = false;
          this.authors = response.data.data;
          this.links = response.data.links;
          console.log(response.data);
        })
        .catch(e => {
          this.authors = null;
          this.links = null;
        });
    }
  },
  mounted() {
    this.getAuthors();
  }
};
</script>
